import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, Subject, timer, Subscription } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class IdleService {
  private idleStart$ = new Subject<void>();
  private timeout$ = new Subject<void>();

  idleStart = this.idleStart$.asObservable();
  timeout = this.timeout$.asObservable();

  private activitySub?: Subscription;
  private running = false;

  constructor(private ngZone: NgZone) {}

  startWatching(idleSeconds: number, timeoutSeconds: number) {
    if (this.running) return;

    this.running = true;

    const idleMs = idleSeconds * 1000;
    const timeoutMs = timeoutSeconds * 1000;

    this.ngZone.runOutsideAngular(() => {
      const activity$ = merge(
        fromEvent(document, 'mousemove'),
        fromEvent(document, 'keydown'),
        fromEvent(document, 'click'),
        fromEvent(document, 'scroll')
      );

      this.activitySub = activity$
        .pipe(
          switchMap(() =>
              timer(idleMs).pipe(
                tap(() => this.ngZone.run(() => this.idleStart$.next())),
                switchMap(() => timer(timeoutMs))
              )
          )
        )
        .subscribe(() => {
          this.ngZone.run(() => this.timeout$.next());
        });
    });
  }

  stopWatching() {
    this.activitySub?.unsubscribe();
    this.running = false;
  }

  isRunning(): boolean {
    return this.running;
  }
}
